<template>
    <div class="mesbox">
      <div class="mesone" id="mesone">
        <p class="mestitle">请您留言</p>
        <div class="mesform" >
            <div class="mesline">
              <label><span class="in_must">*</span>留&#12288;&#12288;言:</label>
              <textarea  rows="3" class="basic-slide" v-model="mescon"  id="mescon" type="text" style="vertical-align:top;" placeholder="请在此输入留言,我们会尽快与您联系"></textarea>
            </div>
            <div class="mesline">
            <label><span class="in_must">*</span>手机号码:</label>
            <input v-model="mestel" class="basic-slide" id="mestel" type="tel" @on-blur="checkNumber" placeholder="请输入手机号码">
            </div>

            <div class="mesline">
                      <label>&#8197;姓&#12288;&#12288;名:</label>
                      <input v-model="mesname" class="basic-slide" id="mesname" type="text" placeholder="请输入姓名">
            </div>
            <div class="mesline">
                      <label>&#8197;公司名称:</label>
                      <input v-model="mescompany" class="basic-slide" id="mescompany" type="text" placeholder="请输入公司名称">
            </div>
            <div class="mesline">
                      <label>&#8197;邮&#12288;&#12288;箱:</label>
                      <input v-model="mesemail" class="basic-slide" id="mesemail" type="email" placeholder="请输入邮箱">
            </div>

        </div>
        <div class="mesboxbtn" >
          <button class="subbtn" style="" @click="callback()">提交</button>
        </div>
      </div>
      <div class="mestwo" style="display:none" id="mestwo">
          <p class="mestitle">尊敬的用户</p>
          <p style=" height:200px;line-height: 200px;font-size:13px;letter-space:1px;color:gray">稍候您将收到客服的来电，请您耐心等待</p>
      </div>
    </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js';
  export default {
    name: "SubmitMessPage",
    mixins:[publicFunClass],
    data(){
      return {
        mestel:'',
        mescon:'',
        mesname:'',
        mescompany:'',
        mesemail:'',
        sessionChannel:'',
        companyCode:'',
        journalType:'',
      }
    },
    methods:{
      checkNumber: function (event) {
          let value = event.currentTarget.value;
          let reg = /(^[0-9]\d*$)/;
          if (!reg.test(value)) {
            event.currentTarget.value ='';
            return false;
          }
      },
      callback:function(){
          if(this.mestel==""||this.mescon==null){
              this.$Message.info("手机号码不能为空");
              return false;
          }
          let pattern =/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          if(!pattern.test(this.mestel)){
              this.$Message.info("号码格式错误,请重新填写");
              return false;
          }
          if(this.mescon==""||this.mescon==null){
              this.$Message.info("留言不能为空");
              return false;
          }
          let that = this;
          let param={
              leavePhone:this.mestel,
              leaveContent:this.mescon,
              leaveName:this.mesname,
              leaveCompany:this.mescompany,
              leaveEmail:this.mesemail,
              leaveChannel:this.sessionChannel,
              companyCode:this.companyCode,
            };
          this.$http.post("api/chatApi/doSaveLeaveMag.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }else{
                 document.getElementById('mesone').style.display ="none";
                 document.getElementById('mestwo').style.display ="block";

                // that.$alert('稍候您将收到客服的来电，请您耐心等待', '提示', {
                //     confirmButtonText: '确定',
                //     showConfirmButton:false,
                //     showClose:false,
                // });
                return true;
              }
          });
          
      },
    },
    created() {
      this.sessionChannel = this.$route.query.sessionChannel;
      this.companyCode = this.$route.query.companyCode;
      if(!this.sessionChannel){
        this.sessionChannel = "";
      }
      if(!this.companyCode){
          this.companyCode ="";
      }
    },
  }
</script>

<style scoped>
.mesbox{
  width: 100%;
  height: 100%;
  max-height: 600px;
	max-width: 600px;
  margin: 0 auto;
  margin-top:0px;
  text-align: center;
  background:#ededed;
	padding-bottom: 10px;
}
.mestitle{
		color: #4daff9;
		font-weight: bold;
		font-size:20px;
    height: 60px;
    line-height: 60px;
}
.subbtn{
  font-size:15px;
  font-weight: normal;
  font-family: "Microsoft YaHei";
  letter-spacing: 2px;
  padding:10px 20px;
  /* box-shadow:0 8px #bbb; */
  cursor: pointer;
  background: #fff;
  color: #4daff9;
  border: 1px solid #4daff9;
  border-radius: 3px;

}
 .subbtn:hover{
  color: #fff;
  background: #0a90f5;
}
.subbtn:focus{
  color: #fff;
  background: #0a90f5;
  outline: none;
}
.subbtn:active{
  background: #0a90f5;
  /* box-shadow:0 3px #aaa; */
  transform: translateY(4px);
}
  label{
  font-family: "Microsoft YaHei";
  letter-spacing: 2px;
  font-size: 14px;
}
.basic-slide{
    outline-style: none ;
    border: 1px solid #ccc;
    border-radius: 3px;
    /* width: 620px; */
    font-size: 14px;
    font-family: "Microsoft YaHei";
    margin-bottom: 15px;
}
.basic-slide:focus{
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 5px rgba(102,175,233,.6);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 5px rgba(102,175,233,.6)
}
.mesbox .mesline{
 text-align: center;
 margin-bottom:10px ;
}
.mesbox .mesline input{
  width: 65%;
  padding: 5px 0px 5px 10px;
}
.mesbox .mesline textarea{
   width: 65%;
   padding: 5px 0px 5px 10px;
}
.mesbox .mesline .in_must{
  color: red;
}
.mesbox .mesboxbtn{
  text-align: center;
  margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/SubmitMessPage.vue